import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home,
    children:[      
      {
        path: '/mall',
        name: 'mall',
        component: () => import('../views/mall.vue')
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/dashboard.vue')
      },   
      {
        path: '/verification',
        name: 'verification',
        component: () => import('../views/terminal/verification/index.vue')
      },   
      {
        path: '/quickConsume',
        name: 'quickConsume',
        component: () => import('../views/terminal/quickConsume/index.vue')
      },
      {
        path: '/productConsume',
        name: 'productConsume',
        component: () => import('../views/terminal/productConsume/index.vue')
      }, 
      {
        path: '/recharge',
        name: 'recharge',
        component: () => import('../views/terminal/recharge/index.vue')
      }, 
      {
        path: '/merchant',
        name: 'merchant',
        component: () => import('../views/operating/merchant/index.vue')
      },
      {
        path: '/addMerchant',
        name: 'addMerchant',
        component: () => import('../views/operating/merchant/add.vue')
      },
      {
        path: '/merchantFinancial',
        name: 'merchantFinancial',
        component: () => import('../views/operating/merchant/financial.vue')
      },
      {
        path: '/editMerchant',
        name: 'editMerchant',
        component: () => import('../views/operating/merchant/edit.vue')
      },
      {
        path: '/businessCircle',
        name: 'businessCircle',
        component: () => import('../views/operating/businessCircle/index.vue')
      },
      {
        path: '/wxMerchant',
        name: 'wxMerchant',
        component: () => import('../views/operating/wxMerchant/index.vue')
      },
      
      {
        path: '/wxMerchantInfo',
        name: 'wxMerchantInfo',
        component: () => import('../views/operating/wxMerchant/info.vue')
      },
      {
        path: '/user',
        name: 'user',
        component: () => import('../views/system/user/index.vue')
      },
      {
        path: '/userInfo',
        name: 'userInfo',
        component: () => import('../views/system/user/info.vue')
      },
      {
        path: '/userRole',
        name: 'userRole',
        component: () => import('../views/system/userRole/index.vue')
      },
      {
        path: '/userRoleInfo',
        name: 'userRoleInfo',
        component: () => import('../views/system/userRole/info.vue')
      },
      {
        path: '/industry',
        name: 'industry',
        component: () => import('../views/system/industry/index.vue')
      },
      {
        path: '/log',
        name: 'log',
        component: () => import('../views/system/log/index.vue')
      },
      {
        path: '/messageTemplate',
        name: 'messageTemplate',
        component: () => import('../views/system/messageTemplate/index.vue')
      },
      {
        path: '/chainStore',
        name: 'chainStore',
        component: () => import('../views/store/chainStore/index.vue')
      },
      {
        path: '/productCategory',
        name: 'productCategory',
        component: () => import('../views/store/productCategory/index.vue')
      },
      {
        path: '/productCategoryInfo',
        name: 'productCategoryInfo',
        component: () => import('../views/store/productCategory/info.vue')
      },
      {
        path: '/product',
        name: 'product',
        component: () => import('../views/store/product/index.vue')
      },
      {
        path: '/productInfo',
        name: 'productInfo',
        component: () => import('../views/store/product/info.vue')
      },
      {
        path: '/productStock',
        name: 'productStock',
        component: () => import('../views/store/productStock/index.vue')
      },
      {
        path: '/productStockNote',
        name: 'productStockNote',
        component: () => import('../views/store/productStockNote/index.vue')
      },
      {
        path: '/chainStoreInfo',
        name: 'chainStoreInfo',
        component: () => import('../views/store/chainStore/info.vue')
      },
      {
        path: '/measuredService',
        name: 'measuredService',
        component: () => import('../views/store/measuredService/index.vue')
      },
      {
        path: '/booth',
        name: 'booth',
        component: () => import('../views/store/booth/index.vue')
      },
      {
        path: '/member',
        name: 'member',
        component: () => import('../views/member/memberManager/index.vue')
      },
      {
        path: '/memberCenter',
        name: 'memberCenter',
        component: () => import('../views/member/memberCenter/index.vue')
      },
      {
        path: '/memberRegister',
        name: 'memberRegister',
        component: () => import('../views/member/memberRegister/index.vue')
      },
      {
        path: '/memberCard',
        name: 'memberCard',
        component: () => import('../views/member/memberCard/index.vue')
      },
      {
        path: '/memberCardInfo',
        name: 'memberCardInfo',
        component: () => import('../views/member/memberCard/MemberCardInfo.vue')
      },
      {
        path: '/memberCardBatch',
        name: 'memberCardBatch',
        component: () => import('../views/member/entityCard/MemberCardBatch.vue')
      },
      {
        path: '/businessCard',
        name: 'businessCard',
        component: () => import('../views/member/businessCard/index.vue')
      },
      {
        path: '/businessCardInfo',
        name: 'businessCardInfo',
        component: () => import('../views/member/businessCard/info.vue')
      },
      {
        path: '/flashSale',
        name: 'flashSale',
        component: () => import('../views/marketing/flashSale/index.vue')
      },
      {
        path: '/flashSaleInfo',
        name: 'flashSaleInfo',
        component: () => import('../views/marketing/flashSale/info.vue')
      },
      {
        path: '/groupBooking',
        name: 'groupBooking',
        component: () => import('../views/marketing/groupBooking/index.vue')
      },
      {
        path: '/groupBookingInfo',
        name: 'groupBookingInfo',
        component: () => import('../views/marketing/groupBooking/info.vue')
      },
      {
        path: '/groupTask',
        name: 'groupTask',
        component: () => import('../views/statistical/groupTask/index.vue')
      },
      {
        path: '/groupOrder',
        name: 'groupOrder',
        component: () => import('../views/statistical/groupOrder/index.vue')
      },
      {
        path: '/redEnvelope',
        name: 'redEnvelope',
        component: () => import('../views/marketing/redEnvelope/index.vue')
      },
      {
        path: '/redEnvelopeNote',
        name: 'redEnvelopeNote',
        component: () => import('../views/marketing/redEnvelopeNote/index.vue')
      },
      {
        path: '/couponList',
        name: 'couponList',
        component: () => import('../views/marketing/coupon/index.vue')
      },
      {
        path: '/couponInfo',
        name: 'couponInfo',
        component: () => import('../views/marketing/coupon/info.vue')
      },
      {
        path: '/couponPackageList',
        name: 'couponPackageList',
        component: () => import('../views/marketing/couponPackage/index.vue')
      },
      {
        path: '/couponPackageInfo',
        name: 'couponPackageInfo',
        component: () => import('../views/marketing/couponPackage/info.vue')
      },
      {
        path: '/shareSale',
        name: 'shareSale',
        component: () => import('../views/marketing/shareSale/index.vue')
      },
      {
        path: '/consumeActive',
        name: 'consumeActive',
        component: () => import('../views/marketing/consumeActive/index.vue')
      },
      {
        path: '/consumeActiveInfo',
        name: 'consumeActiveInfo',
        component: () => import('../views/marketing/consumeActive/info.vue')
      },
      {
        path: '/parameter',
        name: 'parameter',
        component: () => import('../views/system/parameter/index.vue')
      },
      {
        path: '/pay',
        name: 'pay',
        component: () => import('../views/system/pay/index.vue')
      },
      {
        path: '/wechatSet',
        name: 'wechatSet',
        component: () => import('../views/operating/wechatOfficialAccounts/WechatSet.vue')
      },
      {
        path: '/wechatMenu',
        name: 'wechatMenu',
        component: () => import('../views/operating/wechatOfficialAccounts/WechatMenu.vue')
      },
      {
        path: '/wechatReply',
        name: 'wechatReply',
        component: () => import('../views/operating/wechatOfficialAccounts/WechatReply.vue')
      },
      {
        path: '/featurePack',
        name: 'featurePack',
        component: () => import('../views/operating/wechatOfficialAccounts/featurePack.vue')
      },
      {
        path: '/advertising',
        name: 'advertising',
        component: () => import('../views/operating/advertising/index.vue')
      },
      {
        path: '/distribution',
        name: 'distribution',
        component: () => import('../views/operating/distribution/index.vue')
      },
      {
        path: '/storeRebates',
        name: 'storeRebates',
        component: () => import('../views/operating/storeRebates/index.vue')
      },
      {
        path: '/storeShareRebates',
        name: 'storeShareRebates',
        component: () => import('../views/operating/storeShareRebates/index.vue')
      },
      {
        path: '/storeCapitalNote',
        name: 'storeCapitalNote',
        component: () => import('../views/operating/storeCapitalNote/index.vue')
      },    
      {
        path: '/speakers',
        name: 'speakers',
        component: () => import('../views/system/speakers/index.vue')
      },      
      {
        path: '/printer',
        name: 'printer',
        component: () => import('../views/system/printer/index.vue')
      },      
      {
        path: '/weixinNote',
        name: 'weixinNote',
        component: () => import('../views/statistical/weixinNote/index.vue')
      },      
      {
        path: '/alipayNote',
        name: 'alipayNote',
        component: () => import('../views/statistical/alipayNote/index.vue')
      },
      {
        path: '/buyCard',
        name: 'buyCard',
        component: () => import('../views/statistical/buyCard/index.vue')
      },
      {
        path: '/rechargeNote',
        name: 'rechargeNote',
        component: () => import('../views/statistical/rechargeNote/index.vue')
      },
      {
        path: '/pointNote',
        name: 'pointNote',
        component: () => import('../views/statistical/pointNote/index.vue')
      },
      {
        path: '/rewardNote',
        name: 'rewardNote',
        component: () => import('../views/statistical/rewardNote/index.vue')
      },
      {
        path: '/valueNote',
        name: 'valueNote',
        component: () => import('../views/statistical/valueNote/index.vue')
      },
      {
        path: '/orderNote',
        name: 'orderNote',
        component: () => import('../views/statistical/orderNote/index.vue')
      },
      {
        path: '/consumeNote',
        name: 'consumeNote',
        component: () => import('../views/statistical/consumeNote/index.vue')
      },
      {
        path: '/taoBaoRanking',
        name: 'taoBaoRanking',
        component: () => import('../views/taoBao/ranking/index.vue')
      },
      {
        path: '/taoBaoMaterial',
        name: 'taoBaoMaterial',
        component: () => import('../views/taoBao/material/index.vue')
      },
      {
        path: '/taoBaoProduce',
        name: 'taoBaoProduce',
        component: () => import('../views/taoBao/produce/index.vue')
      },
      {
        path: '/taoBaoOrder',
        name: 'taoBaoOrder',
        component: () => import('../views/taoBao/order/index.vue')
      },
      {
        path: '/pddProduct',
        name: 'pddProduct',
        component: () => import('../views/pdd/product/index.vue')
      },
      {
        path: '/pddPid',
        name: 'pddPid',
        component: () => import('../views/pdd/pid/index.vue')
      }

    ]
  }  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
